<template>
    <CurrencyRateDetails/>
</template>
<script>
import CurrencyRateDetails from '../../components/currency-rates/CurrencyRateDetails';

export default {
  components: {
    CurrencyRateDetails,
  },
};
</script>
